__webpack_require__.p = "/offer-content-generator-improve-dropdown/referrals-hub/";